import formatDecimals from "@/mixins/ValuesFormat";
import getTimeFromSecondsDurationFormatMixin from "@/mixins/DateMixin";

export default {
    mixins: [formatDecimals, getTimeFromSecondsDurationFormatMixin],
    methods: {
        buildStatistics(statistics, operationType) {
            let stats = {
                startDate: statistics.start_date,
                endDate: statistics.end_date,
                area: this.formatDecimals(statistics.area, 3),
                distance: statistics.distance,
                time: statistics.time,
                productivity: this.formatDecimals(statistics.productivity),
                speed: this.formatDecimals(statistics.speed)
            }

            let tmpStatistics = {}
            let tmpOperators = []
            let tmpVehicles = []
            let tmpVarieties = []
            let tmpProducts = []

            tmpOperators = statistics.operators
            tmpVehicles = statistics.vehicles

            tmpStatistics.TOTAL = {
                name: this.$t('OperationsStatisticsBuilder.Totais do Trabalho'),
                stats: [
                    {
                        title: this.$t('OperationsStatisticsBuilder.Área trabalhada'),
                        value: stats.area,
                        symbol: 'ha'
                    }
                ]
            }

            tmpStatistics.PERFORMANCE = {
                name: this.$t('OperationsStatisticsBuilder.Desempenho'),
                stats: [
                    {
                        title: this.$t('OperationsStatisticsBuilder.Velocidade média'),
                        value: stats.speed,
                        symbol: 'km/h'
                    },
                    {
                        title: this.$t('OperationsStatisticsBuilder.Duração'),
                        value: this.getTimeFromSecondsDurationFormatMixin(stats.time * 3600),
                        symbol: ''
                    },
                    {
                        title: this.$t('OperationsStatisticsBuilder.Eficiência operacional'),
                        value: stats.productivity,
                        symbol: 'ha/h'
                    }
                ]
            }
            let uom = operationType === 'DRY_APPLICATION' ? 'T' : 'L'
            switch (operationType) {
                case 'SEEDING':
                    tmpStatistics.TOTAL.stats.push({
                            title: this.$t('OperationsStatisticsBuilder.Plantio total'),
                            value: statistics.seeding_total !== undefined ? this.formatDecimals(statistics.seeding_total) : 'N/D',
                            symbol: statistics.seeding_total !== undefined ? this.$t('OperationsStatisticsBuilder.sementes') : ''
                        },
                        {
                            title: this.$t('OperationsStatisticsBuilder.Taxa de plantio'),
                            value: statistics.seeding_rate !== undefined ? this.formatDecimals(statistics.seeding_rate) : 'N/D',
                            symbol: statistics.seeding_rate !== undefined ? this.$t('OperationsStatisticsBuilder.sementes/ha') : ''
                        },
                        {
                            title: this.$t('OperationsStatisticsBuilder.Plantio alvo total'),
                            value: statistics.target_total !== undefined ? this.formatDecimals(statistics.target_total) : 'N/D',
                            symbol: statistics.target_total !== undefined ? this.$t('OperationsStatisticsBuilder.sementes') : ''
                        },
                        {
                            title: this.$t('OperationsStatisticsBuilder.Taxa alvo de plantio'),
                            value: statistics.target_rate !== undefined ? this.formatDecimals(statistics.target_rate) : 'N/D',
                            symbol: statistics.target_rate !== undefined ? this.$t('OperationsStatisticsBuilder.sementes/ha') : ''
                        })

                    tmpVarieties = statistics.varieties
                    break
                case 'HARVEST':
                    tmpStatistics.TOTAL.stats.push({
                            title: this.$t('OperationsStatisticsBuilder.Produtividade'),
                            value: statistics.yield !== undefined ? this.formatDecimals(statistics.yield) : 'N/D',
                            symbol: statistics.yield !== undefined ? 't/ha' : ''
                        },
                        {
                            title: this.$t('OperationsStatisticsBuilder.Total colhido'),
                            value: statistics.total_yield !== undefined ? this.formatDecimals(statistics.total_yield) : 'N/D',
                            symbol: statistics.total_yield !== undefined ? 't' : ''
                        },
                        {
                            title: this.$t('OperationsStatisticsBuilder.Umidade'),
                            value: statistics.moisture !== undefined ? this.formatDecimals(statistics.moisture) : 'N/D',
                            symbol: statistics.moisture !== undefined ? '%' : ''
                        },
                        {
                            title: this.$t('OperationsStatisticsBuilder.Rendimento bruto'),
                            value: statistics.wet_weight !== undefined ? this.formatDecimals(statistics.wet_weight) : 'N/D',
                            symbol: statistics.wet_weight !== undefined ? 't/ha' : ''
                        },
                        {
                            title: this.$t('OperationsStatisticsBuilder.Peso bruto'),
                            value: statistics.total_wet_weight !== undefined ? this.formatDecimals(statistics.total_wet_weight) : 'N/D',
                            symbol: statistics.total_wet_weight !== undefined ? 't' : ''
                        })

                    tmpStatistics.PERFORMANCE.stats.push({
                            title: this.$t('OperationsStatisticsBuilder.Rendimento (Seco)'),
                            value: statistics.throughput_dry !== undefined ? this.formatDecimals(statistics.throughput_dry) : 'N/D',
                            symbol: statistics.throughput_dry !== undefined ? 't/h' : ''
                        },
                        {
                            title: this.$t('OperationsStatisticsBuilder.Taxa de colheita'),
                            value: statistics.throughput_wet !== undefined ? this.formatDecimals(statistics.throughput_wet) : 'N/D',
                            symbol: statistics.throughput_wet !== undefined ? 't/h' : ''
                        })

                    tmpVarieties = statistics.varieties
                    break
                case 'TILLAGE':
                    tmpStatistics.TOTAL.stats.push({
                            title: this.$t('OperationsStatisticsBuilder.Profundidade'),
                            value: statistics.actual_depth !== undefined ? this.formatDecimals(statistics.actual_depth) : 'N/D',
                            symbol: statistics.actual_depth !== undefined ? 'cm' : ''
                        },
                        {
                            title: this.$t('OperationsStatisticsBuilder.Profundidade alvo'),
                            value: statistics.target_depth !== undefined ? this.formatDecimals(statistics.target_depth) : 'N/D',
                            symbol: statistics.target_depth !== undefined ? 'cm' : ''
                        })
                    break
                case 'MOWING':
                    tmpVarieties = statistics.varieties
                    break
                case 'DRY_APPLICATION':
                    tmpStatistics.TOTAL.stats.push({
                            title: this.$t('OperationsStatisticsBuilder.Taxa de aplicação'),
                            value: statistics.application_rate !== undefined ? this.formatDecimals(statistics.application_rate) : 'N/D',
                            symbol: statistics.application_rate !== undefined ? `${uom}/ha` : ''
                        },
                        {
                            title: this.$t('OperationsStatisticsBuilder.Aplicação total'),
                            value: statistics.applied_total !== undefined ? this.formatDecimals(statistics.applied_total) : 'N/D',
                            symbol: statistics.applied_total !== undefined ? `${uom}` : ''
                        },
                        {
                            title: this.$t('OperationsStatisticsBuilder.Taxa alvo de aplicação'),
                            value: statistics.target_rate !== undefined ? this.formatDecimals(statistics.target_rate) : 'N/D',
                            symbol: statistics.target_rate !== undefined ? `${uom}/ha` : ''
                        },
                        {
                            title: this.$t('OperationsStatisticsBuilder.Aplicação alvo total'),
                            value: statistics.target_total !== undefined ? this.formatDecimals(statistics.target_total) : 'N/D',
                            symbol: statistics.target_total !== undefined ? `${uom}` : ''
                        })
                    tmpProducts = statistics.products
                    break
                case 'LIQUID_APPLICATION':
                    tmpStatistics.TOTAL.stats.push({
                            title: this.$t('OperationsStatisticsBuilder.Taxa de aplicação'),
                            value: statistics.application_rate !== undefined ? this.formatDecimals(statistics.application_rate) : 'N/D',
                            symbol: statistics.application_rate !== undefined ? `${uom}/ha` : ''
                        },
                        {
                            title: this.$t('OperationsStatisticsBuilder.Aplicação total'),
                            value: statistics.applied_total !== undefined ? this.formatDecimals(statistics.applied_total) : 'N/D',
                            symbol: statistics.applied_total !== undefined ? `${uom}` : ''
                        },
                        {
                            title: this.$t('OperationsStatisticsBuilder.Taxa alvo de aplicação'),
                            value: statistics.target_rate !== undefined ? this.formatDecimals(statistics.target_rate) : 'N/D',
                            symbol: statistics.target_rate !== undefined ? `${uom}/ha` : ''
                        },
                        {
                            title: this.$t('OperationsStatisticsBuilder.Aplicação alvo total'),
                            value: statistics.target_total !== undefined ? this.formatDecimals(statistics.target_total) : 'N/D',
                            symbol: statistics.target_total !== undefined ? `${uom}` : ''
                        },
                        {
                            title: this.$t('OperationsStatisticsBuilder.Pressão'),
                            value: statistics.actual_pressure !== undefined ? this.formatDecimals(statistics.actual_pressure) : 'N/D',
                            symbol: statistics.actual_pressure !== undefined ? 'kPa' : ''
                        },
                        {
                            title: this.$t('OperationsStatisticsBuilder.Pressão alvo'),
                            value: statistics.target_pressure !== undefined ? this.formatDecimals(statistics.target_pressure) : 'N/D',
                            symbol: statistics.target_pressure !== undefined ? 'kPa' : ''
                        })
                    tmpProducts = statistics.products
                    break
            }

            tmpStatistics.PERFORMANCE.stats.push({
                    title: this.$t('OperationsStatisticsBuilder.Total de combustível'),
                    value: statistics.fuel !== undefined ? this.formatDecimals(statistics.fuel) : 'N/D',
                    symbol: statistics.fuel !== undefined ? 'L' : ''
                },
                {
                    title: this.$t('OperationsStatisticsBuilder.Taxa de combustível (área)'),
                    value: statistics.fuel_rate_by_area !== undefined ? this.formatDecimals(statistics.fuel_rate_by_area) : 'N/D',
                    symbol: statistics.fuel_rate_by_area !== undefined ? 'L/ha' : ''
                },
                {
                    title: this.$t('OperationsStatisticsBuilder.Taxa de combustível (tempo)'),
                    value: statistics.fuel_rate_by_time !== undefined ? this.formatDecimals(statistics.fuel_rate_by_time) : 'N/D',
                    symbol: statistics.fuel_rate_by_time !== undefined ? 'L/h' : ''
                })

            return {
                statistics: tmpStatistics,
                operators: tmpOperators,
                vehicles: tmpVehicles,
                varieties: tmpVarieties,
                products: tmpProducts
            }
        }
    }
}
